export const getDataLayerPush = () => {
  if (!IS_BROWSER) return null
  const win = window as any
  if (win && win.dataLayer) {
    return (data: any) => win.dataLayer.push(data)
  }
  return null
}
